<template>
  <div class="flex justify-start items-center gap-7 md:gap-5 md:flex-col">
    <img
      class="h-[70px] md:h-[93px]"
      :src="durationImages[service.duration]"
      height="70"
    />
    <div class="flex flex-col text-center text-slate-950">
      <div v-if="protagonistInterviewee">{{ `Hasta ${service.chapters} capítulos` }}</div>
      <div v-if="!protagonistInterviewee">
        {{ `Hasta ${service.max_interviewees} entrevistados` }}
      </div>
    </div>
  </div>
</template>

<script>
import stopwatch60min from "@assets/images/landing/pricing/stopwatch-60-min.svg";
import stopwatch90min from "@assets/images/landing/pricing/stopwatch-90-min.svg";
import stopwatch120min from "@assets/images/landing/pricing/stopwatch-120-min.svg";

export default {
  inject: ["isPriceHidden"],
  props: {
    service: {
      type: Object,
    },
    protagonistInterviewee: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    durationImages() {
      return {
        60: stopwatch60min,
        90: stopwatch90min,
        120: stopwatch120min,
      };
    },
  },
};
</script>
